import { Palette } from '.';
export default (color = Palette.Fill.x50, isBold = false): string => `${isBold ? 2 : 1}px solid ${color}`;
